import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'

const NotificationEditRoutes = ({ notificationId }: { notificationId: number }) => (
  <Routes>
    <Route index element={<Details notificationId={notificationId} />} />
  </Routes>
)

export default NotificationEditRoutes
